import React from 'react'

const description = (props) => {
  return (
    <section id='description'>
        <article className='service'>
                <div className='service__head'>
                    <h3>{props.title}</h3>
                </div>
                {props.data}
                    <div className='services__item-cta'>
                    <a href={props.link} target='_blank' className='btn'>Github</a>
                    </div>
         </article>
    </section>
  )
}

export default description